import { api } from "./apiClient";
import { SesionEntry } from "@/types/sesion";

export const sesionesService = {
  getAll: () => api.get<SesionEntry[]>("/sesiones/"),
};
